module.exports = __webpack_public_path__ + "static/media/manu-2.39504962.png";